module.exports = __webpack_public_path__ + "static/media/Illus-Employee_3.84a3892b.png";